import { V2Device, Suggestions } from 'ctp-search-device';
import { DevicesState,
  IDevice,
  IDeviceActions,
  IDevicesListState,
  IDeviceTollDomains,
  INavigation } from './types';

const getters = {
  getDevicesListState(state: DevicesState): IDevicesListState {
    return state.devicesListComponentsState;
  },
  getNavigationConfiguration(state: DevicesState): INavigation {
    return state.devices.navigation;
  },
  getNumberOfActiveDevices(state: DevicesState): number {
    return state.devices.numberOfActiveDevices;
  },
  getDevices(state: DevicesState): IDevice {
    return state.devices;
  },
  getDevicesList(state: DevicesState): V2Device[] {
    return state.devices.devicesList;
  },
  getUserSelectionDevices(state: DevicesState): string[] {
    return state.userSelection.devices;
  },
  getNumberUserSelectionDevices(state: DevicesState): number {
    return state.userSelection.devices.length;
  },
  getUserSelectionDevicesActionsNames(state: DevicesState): string[] {
    return Object.values(state.userSelection.actions).map(x => x.label);
  },
  getUserSelectionDevicesActions(state: DevicesState): { [key: string]: IDeviceActions } {
    return state.userSelection.actions;
  },
  getIsLastDevicePage(state: DevicesState): boolean {
    return state.devices.navigation.isLastDevicePage;
  },
  getTotalDevices(state: DevicesState): number {
    return state.devices.total;
  },
  getSuggestions(state: DevicesState): Suggestions | undefined {
    return state.suggestions;
  },
  getDevicesHistory(state: DevicesState): any[] {
    return state.devices.devicesHistory;
  },
  getTollDomainsOfDevices(state: DevicesState): any[] {
    return state.devices.devicesTollDomainsList;
  },
  getTollDomainsNamesOfDevices(state: DevicesState): IDeviceTollDomains[] {
    return state.devices.devicesTollDomainsNames;
  }
};

export default getters;
